import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DingConnectPanel from "@/components/DingConnectPanel";
import ProviderOrchestratorPanel from "@/components/ProviderOrchestratorPanel";
import ProviderDashboardPanel from "@/components/ProviderDashboardPanel";
import ProviderStatsPanel from "@/components/ProviderStatsPanel";
import FailoverHistoryPanel from "@/components/FailoverHistoryPanel";
import {
  Shield,
  Settings2,
  History,
  LayoutDashboard,
  BarChart3,
} from "lucide-react";
import { useBranding } from "@/context/BrandingContext";

const TABS = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "orchestrator", label: "Providers", icon: Settings2 },
  { key: "stats", label: "Statistics", icon: BarChart3 },
  { key: "history", label: "Failover history", icon: History },
];

export default function ProviderManagement() {
  const { t } = useTranslation();
  const { brand } = useBranding();
  const [tab, setTab] = useState("dashboard");

  return (
    <div className="space-y-6" data-testid="provider-management-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
            {t("providers.breadcrumb")}
          </div>
          <h1
            className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            {t("providers.title", { brand: brand.brand_name })}
          </h1>
          <p className="text-slate-500 text-sm mt-1">
            {t("providers.subtitle")}
          </p>
        </div>
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900 text-white text-xs font-semibold">
          <Shield className="w-3.5 h-3.5" />
          {t("providers.master_only")}
        </span>
      </div>

      <div className="flex items-center gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map((tabDef) => {
          const Icon = tabDef.icon;
          const active = tab === tabDef.key;
          return (
            <button
              key={tabDef.key}
              onClick={() => setTab(tabDef.key)}
              data-testid={`provider-tab-${tabDef.key}`}
              className={
                "inline-flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors whitespace-nowrap " +
                (active
                  ? "border-[#0F62FE] text-[#0F62FE]"
                  : "border-transparent text-slate-500 hover:text-slate-800")
              }
            >
              <Icon className="w-4 h-4" />
              {tabDef.label}
            </button>
          );
        })}
      </div>

      {tab === "dashboard" && <ProviderDashboardPanel />}
      {tab === "orchestrator" && (
        <>
          <ProviderOrchestratorPanel />
          <DingConnectPanel />
        </>
      )}
      {tab === "stats" && <ProviderStatsPanel />}
      {tab === "history" && <FailoverHistoryPanel />}
    </div>
  );
}
